module.exports = __webpack_public_path__ + "media/images/athletes/1339-d11788d8005679969445fa6ba71f9a99.png";